"use strict";
//
// Defines the WMS namespace and contained classes.
//
// Generated File - DO NOT EDIT
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.WMS = void 0;
var WMS;
(function (WMS) {
    let V2;
    (function (V2) {
        let Customer;
        (function (Customer_1) {
            let Models;
            (function (Models) {
                class Alerts {
                    ExpirationNotificationThreshold;
                    NotifyShipTo;
                    FromEmailAddress;
                    SenderName;
                    ReplyToAddress;
                    WebHookParameters;
                }
                Models.Alerts = Alerts;
                class AsnPreCheck {
                    RequireScacForAsn;
                    RequireAttachedDocuments;
                    AsnPreCheckOptions;
                    OrderLevelFlexFields;
                    OrderItemLevelFlexFields;
                }
                Models.AsnPreCheck = AsnPreCheck;
                let AsnPreCheckOptions;
                (function (AsnPreCheckOptions) {
                    AsnPreCheckOptions[AsnPreCheckOptions["None"] = 0] = "None";
                    AsnPreCheckOptions[AsnPreCheckOptions["HasWeight"] = 1] = "HasWeight";
                    AsnPreCheckOptions[AsnPreCheckOptions["HasVolume"] = 2] = "HasVolume";
                    AsnPreCheckOptions[AsnPreCheckOptions["HasPackages"] = 4] = "HasPackages";
                    AsnPreCheckOptions[AsnPreCheckOptions["HasCarrier"] = 8] = "HasCarrier";
                    AsnPreCheckOptions[AsnPreCheckOptions["HasBillOfLading"] = 16] = "HasBillOfLading";
                    AsnPreCheckOptions[AsnPreCheckOptions["HasLoadNumber"] = 32] = "HasLoadNumber";
                    AsnPreCheckOptions[AsnPreCheckOptions["HasPoNumber"] = 64] = "HasPoNumber";
                    AsnPreCheckOptions[AsnPreCheckOptions["IsClosed"] = 128] = "IsClosed";
                })(AsnPreCheckOptions = Models.AsnPreCheckOptions || (Models.AsnPreCheckOptions = {}));
                ;
                let BarcodeDefElementType;
                (function (BarcodeDefElementType) {
                    BarcodeDefElementType[BarcodeDefElementType["TrackBy"] = 0] = "TrackBy";
                    BarcodeDefElementType[BarcodeDefElementType["SavedElement"] = 1] = "SavedElement";
                    BarcodeDefElementType[BarcodeDefElementType["Skip"] = 2] = "Skip";
                })(BarcodeDefElementType = Models.BarcodeDefElementType || (Models.BarcodeDefElementType = {}));
                ;
                class Component {
                    ItemIdentifier;
                    Qualifier;
                    Qty;
                    NonSkuMaterial;
                }
                Models.Component = Component;
                class Customer {
                    Rel;
                    ReadOnly;
                    CompanyInfo;
                    PrimaryContact;
                    OtherContacts;
                    WebSite;
                    ExternalId;
                    Facilities;
                    PrimaryFacilityIdentifier;
                    Options;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Customer = Customer;
                class CustomerBrief {
                    Rel;
                    CustomerId;
                    CompanyName;
                    Deactivated;
                    Href;
                    LinkName;
                    Links;
                }
                Models.CustomerBrief = CustomerBrief;
                class CustomerBriefList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.CustomerBriefList = CustomerBriefList;
                class CustomerList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.CustomerList = CustomerList;
                class CustomerManualRates {
                    Rel;
                    XactionTypeRates;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.CustomerManualRates = CustomerManualRates;
                class CustomerReadOnly {
                    CustomerId;
                    CreationDate;
                    Deactivated;
                }
                Models.CustomerReadOnly = CustomerReadOnly;
                class DimensionNet {
                    NetWeight;
                    Length;
                    Width;
                    Height;
                    Weight;
                }
                Models.DimensionNet = DimensionNet;
                class DirectedPutAway {
                    LocationZones;
                    PalletLocationZones;
                    OverAllocLocationZones;
                    PreferredLocationIdentifier;
                    ForceIntoPreferredLocation;
                    AllowMixedItemStorage;
                    AllowMixedLotStorage;
                    MixedExpirationDaysThreshold;
                }
                Models.DirectedPutAway = DirectedPutAway;
                class Edi {
                    CustInterchangeId;
                    CustInterchangeIdQual;
                    ThreeplInterchangeId;
                    ThreeplInterchangeIdQual;
                    TradingPartnerId;
                }
                Models.Edi = Edi;
                class HazMat {
                    IsHazMat;
                    Id;
                    ShippingName;
                    HazardClass;
                    PackingGroup;
                    FlashPoint;
                    LabelCode;
                    Flag;
                }
                Models.HazMat = HazMat;
                class InventoryUnit {
                    UnitIdentifier;
                    MinimumStock;
                    MaximumStock;
                    ReorderQuantity;
                    InventoryMethod;
                }
                Models.InventoryUnit = InventoryUnit;
                class Item {
                    Rel;
                    ReadOnly;
                    ItemId;
                    Sku;
                    Upc;
                    Description;
                    Description2;
                    InventoryCategory;
                    ClassificationIdentifier;
                    Nmfc;
                    Cost;
                    Price;
                    Temperature;
                    MaxAllocateFromPickline;
                    AccountRef;
                    CountryOfManufacture;
                    HarmonizedCode;
                    Qualifiers;
                    QualifierRenamers;
                    Kit;
                    Options;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Item = Item;
                class ItemBrief {
                    Rel;
                    ItemId;
                    Sku;
                    Description;
                    Deactivated;
                    IsKit;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ItemBrief = ItemBrief;
                class ItemBriefList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ItemBriefList = ItemBriefList;
                class ItemList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ItemList = ItemList;
                class ItemOptions {
                    InventoryUnit;
                    SecondaryUnit;
                    PackageUnit;
                    TrackBys;
                    Pallets;
                    HazMat;
                    DirectedPutAway;
                    DaysBetweenCounts;
                    AutoHoldOnReceive;
                }
                Models.ItemOptions = ItemOptions;
                class ItemQualifier {
                    Rel;
                    Qualifier;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ItemQualifier = ItemQualifier;
                let ItemRatePolicy;
                (function (ItemRatePolicy) {
                    ItemRatePolicy[ItemRatePolicy["NoCharge"] = 0] = "NoCharge";
                    ItemRatePolicy[ItemRatePolicy["Standard"] = 1] = "Standard";
                    ItemRatePolicy[ItemRatePolicy["Custom"] = 2] = "Custom";
                })(ItemRatePolicy = Models.ItemRatePolicy || (Models.ItemRatePolicy = {}));
                ;
                class ItemReadOnly {
                    CustomerIdentifier;
                    ItemId;
                    CreationDate;
                    LastModifiedDate;
                    Deactivated;
                    LastPriceChange;
                    HasStorageRates;
                    RowVersion;
                }
                Models.ItemReadOnly = ItemReadOnly;
                class ItemSummary {
                    Rel;
                    CustomerIdentifier;
                    ItemId;
                    Sku;
                    Upc;
                    Description;
                    Price;
                    TrackBys;
                    InventoryUnitIdentifier;
                    SecondaryUnit;
                    PackageUnit;
                    Pallets;
                    Qualifiers;
                    AutoHoldOnReceive;
                    AutoHoldExpirationDaysThreshold;
                    IsAssembly;
                    ClassificationIdentifier;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ItemSummary = ItemSummary;
                class ItemSummaryList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ItemSummaryList = ItemSummaryList;
                class Kit {
                    MaterialNotes;
                    Components;
                }
                Models.Kit = Kit;
                let KitInclusion;
                (function (KitInclusion) {
                    KitInclusion[KitInclusion["Either"] = 0] = "Either";
                    KitInclusion[KitInclusion["KitsOnly"] = 1] = "KitsOnly";
                    KitInclusion[KitInclusion["NonKitsOnly"] = 2] = "NonKitsOnly";
                })(KitInclusion = Models.KitInclusion || (Models.KitInclusion = {}));
                ;
                class Options {
                    Alerts;
                    Storage;
                    Edi;
                    Receiving;
                    Shipping;
                    Packaging;
                    OtherSystemBehaviors;
                    MobileProcessingBehaviors;
                    UserInterface;
                    SavedElements;
                }
                Models.Options = Options;
                class OtherSystemBehaviors {
                    FlexFields;
                    AllowDuplicateUPCs;
                }
                Models.OtherSystemBehaviors = OtherSystemBehaviors;
                class PackageUnit {
                    Imperial;
                    Metric;
                    Upc;
                    UnitIdentifier;
                    InventoryUnitsPerUnit;
                }
                Models.PackageUnit = PackageUnit;
                class Packaging {
                    SmallParcelUsps3rdParty;
                    Ucc128ManufacturersId;
                    UseVendorIdOnBol;
                    SpsCloseOnUpdate;
                    SpsDisableAutoClearBinId;
                    SmallParcelReturnShippingCost;
                    SmallParcelReturnFedExService;
                    SmallParcelUspsReturnType;
                    SmallParcelReturnUpsService;
                    SmallParcelReturnDefaultChecked;
                    SmallParcelHighVolumeDefaultChecked;
                    SmallParcelHighVolumeZplBatched;
                    SmallParcelReferences;
                    SmallParcelIntlDutyBillType;
                    SmallParcelCustomizeDuties;
                    SmallParcelDutiesAndTaxes;
                    SmallParcelCreatePackagesOnFind;
                    SmallParcelRateShoppingCarrierIds;
                    SmallParcelRateShoppingLogic;
                    SmallParcelZplPrintDefault;
                    SmallParcelAutoRateShopOnShip;
                    SmallParcelDisableClickToPack;
                    SmallParcelReturnPitneyExpService;
                    SmallParcelReturnPitneyStdService;
                    SmallParcelRateShopFilter;
                }
                Models.Packaging = Packaging;
                class Pallets {
                    TypeIdentifier;
                    Tie;
                    High;
                    Qty;
                    Imperial;
                    Metric;
                    Upc;
                }
                Models.Pallets = Pallets;
                class Receiving {
                    PurchaseOrders;
                    CreateMultipleMus;
                    DisplayWeightFieldForReceipt;
                    ReceiveAgainstAsns;
                    SuggestedPutAwayEnabled;
                    AutoFillTrackBys;
                    TrackLocation;
                    TrackPallets;
                    TrackSupplier;
                    InheritOriginalReceiptDateOnTransfer;
                }
                Models.Receiving = Receiving;
                class SavedElementDef {
                    Name;
                    Required;
                }
                Models.SavedElementDef = SavedElementDef;
                class SavedElementDefs {
                    Orders;
                    Receivers;
                }
                Models.SavedElementDefs = SavedElementDefs;
                class SavedElementTransDef {
                    Defs;
                    ItemDefs;
                }
                Models.SavedElementTransDef = SavedElementTransDef;
                class ScriptInfo {
                    TemplateIdentifier;
                    Parameters;
                }
                Models.ScriptInfo = ScriptInfo;
                class ScriptParameterInfo {
                    ParameterIdentifier;
                    Value;
                }
                Models.ScriptParameterInfo = ScriptParameterInfo;
                class SecondaryUnit {
                    InventoryAlso;
                    Upc;
                    UnitIdentifier;
                    InventoryUnitsPerUnit;
                }
                Models.SecondaryUnit = SecondaryUnit;
                class Shipping {
                    NextMasterBolId;
                    NextMasterBolIdOverride;
                    BolNumAsTransNum;
                    AutoConfirmOrderOnTrackingUpdate;
                    FulfillmentInvoicing;
                    OrderQueue;
                    AutoPrintCartonLabelDefault;
                    SmartPackScaleEnabled;
                    RequireTrackingNumber;
                    UpsAccountNumber;
                    UpsAccountZip;
                    FedExAccountNumber;
                    PrepopulateCarrierInfo;
                    PackingListLogoUrl;
                    PackingListFooterUrl;
                    RounduptoFullMU;
                    QuickBooksPaymentTerms;
                    AsnPreCheck;
                    AutoBatchOptions;
                }
                Models.Shipping = Shipping;
                class Storage {
                    FuelSurcharge;
                    SetInvoiceDateToXactionConfirmDate;
                    AccountingCustomerName;
                    AutoFillChargesOnConfirm;
                }
                Models.Storage = Storage;
                let StorageRateInclusion;
                (function (StorageRateInclusion) {
                    StorageRateInclusion[StorageRateInclusion["Either"] = 0] = "Either";
                    StorageRateInclusion[StorageRateInclusion["RatesOnly"] = 1] = "RatesOnly";
                    StorageRateInclusion[StorageRateInclusion["NoRatesOnly"] = 2] = "NoRatesOnly";
                })(StorageRateInclusion = Models.StorageRateInclusion || (Models.StorageRateInclusion = {}));
                ;
                class TrackBys {
                    TrackLotNumber;
                    TrackSerialNumber;
                    TrackExpirationDate;
                    TrackCost;
                    OutboundMobileSerialization;
                    AutoHoldExpirationDaysThreshold;
                    IsPickLotNumberRequired;
                    IsPickSerialNumberRequired;
                    IsPickExpirationDateRequired;
                }
                Models.TrackBys = TrackBys;
                class UserInterface {
                    HideLocationSelectedList;
                    ExcludeLocationsWithZeroInventory;
                    AutoCheckAutoReallocateOnReceive;
                    TransactionConfirmInvoiceCreateDefault;
                    MobileReceiptQuantityOneDefault;
                    ReallocateAtPickTime;
                    BrandingImageId;
                    Dashboard;
                }
                Models.UserInterface = UserInterface;
                class XactionManualChargeTypeRate {
                    PriceCalcRateId;
                    ChargeLabel;
                    UnitDescription;
                    ChargePerUnit;
                    Notes;
                    GlAcctNum;
                    PeachTreeItem;
                    PeachTreeItemDescription;
                    PeachTreeArAcct;
                    Required;
                    TaxCode;
                    TaxRate;
                    TaxAgency;
                    Script;
                }
                Models.XactionManualChargeTypeRate = XactionManualChargeTypeRate;
                class XactionManualChargeTypeRates {
                    ChargeType;
                    DefaultGlAcctNum;
                    Script;
                    Rates;
                }
                Models.XactionManualChargeTypeRates = XactionManualChargeTypeRates;
                class XactionTypeManualRates {
                    WarehouseTransactionType;
                    SubType;
                    ChargeTypeRates;
                    Script;
                }
                Models.XactionTypeManualRates = XactionTypeManualRates;
            })(Models = Customer_1.Models || (Customer_1.Models = {}));
        })(Customer = V2.Customer || (V2.Customer = {}));
        let Event;
        (function (Event) {
            let Models;
            (function (Models) {
                let EventType;
                (function (EventType) {
                    EventType[EventType["Test"] = 0] = "Test";
                    EventType[EventType["CycleCountFiring"] = 1] = "CycleCountFiring";
                    EventType[EventType["CycleCountCounting"] = 2] = "CycleCountCounting";
                    EventType[EventType["CycleCountCompletedTask"] = 3] = "CycleCountCompletedTask";
                    EventType[EventType["CycleCountCompletedFiring"] = 4] = "CycleCountCompletedFiring";
                    EventType[EventType["CycleCountConfirmedTask"] = 5] = "CycleCountConfirmedTask";
                    EventType[EventType["CycleCountConfirmedFiring"] = 6] = "CycleCountConfirmedFiring";
                })(EventType = Models.EventType || (Models.EventType = {}));
                ;
            })(Models = Event.Models || (Event.Models = {}));
        })(Event = V2.Event || (V2.Event = {}));
        let Generic;
        (function (Generic) {
            let Models;
            (function (Models) {
                class AlertIdentifier {
                    Id;
                }
                Models.AlertIdentifier = AlertIdentifier;
                class AuditCountIdentifier {
                    Uri;
                    Id;
                }
                Models.AuditCountIdentifier = AuditCountIdentifier;
                class BatchIdentifier {
                    NameKey;
                    Id;
                }
                Models.BatchIdentifier = BatchIdentifier;
                class BatchNameKey {
                    CustomerIdentifier;
                    Name;
                }
                Models.BatchNameKey = BatchNameKey;
                class Billing {
                    BillingCharges;
                }
                Models.Billing = Billing;
                class BillingCharge {
                    ChargeType;
                    Subtotal;
                    Details;
                }
                Models.BillingCharge = BillingCharge;
                class BillingChargeDetail {
                    WarehouseTransactionPriceCalcId;
                    NumUnits;
                    ChargeLabel;
                    UnitDescription;
                    ChargePerUnit;
                    GlAcctNum;
                    Sku;
                    PtItem;
                    PtItemDescription;
                    PtArAcct;
                    SystemGenerated;
                    TaxCode;
                    RecurringChargeDetails;
                }
                Models.BillingChargeDetail = BillingChargeDetail;
                class CapacityTypeIdentifier {
                    Name;
                    Id;
                }
                Models.CapacityTypeIdentifier = CapacityTypeIdentifier;
                class CarrierIdentifier {
                    Name;
                    Id;
                }
                Models.CarrierIdentifier = CarrierIdentifier;
                class CellCarrierIdentifier {
                    Name;
                    Id;
                }
                Models.CellCarrierIdentifier = CellCarrierIdentifier;
                class ChannelIdentifier {
                    Name;
                    Id;
                }
                Models.ChannelIdentifier = ChannelIdentifier;
                class ContactIdentifier {
                    Name;
                    Id;
                }
                Models.ContactIdentifier = ContactIdentifier;
                class ContactInfo {
                    ContactId;
                    CompanyName;
                    Name;
                    Title;
                    Address1;
                    Address2;
                    City;
                    State;
                    Zip;
                    Country;
                    PhoneNumber;
                    Fax;
                    EmailAddress;
                    Dept;
                    IsAddressResidential;
                    Code;
                    AddressStatus;
                }
                Models.ContactInfo = ContactInfo;
                class CustomerGroupIdentifier {
                    Name;
                    Id;
                }
                Models.CustomerGroupIdentifier = CustomerGroupIdentifier;
                class CustomerIdentifier {
                    ExternalId;
                    Name;
                    Id;
                }
                Models.CustomerIdentifier = CustomerIdentifier;
                class Dimension {
                    Length;
                    Width;
                    Height;
                    Weight;
                }
                Models.Dimension = Dimension;
                class FacilityIdentifier {
                    Name;
                    Id;
                }
                Models.FacilityIdentifier = FacilityIdentifier;
                class InventoryUnitsPer {
                    UnitIdentifier;
                    InventoryUnitsPerUnit;
                }
                Models.InventoryUnitsPer = InventoryUnitsPer;
                class ItemClassificationIdentifier {
                    Name;
                    Id;
                }
                Models.ItemClassificationIdentifier = ItemClassificationIdentifier;
                class ItemIdentifier {
                    Sku;
                    Id;
                }
                Models.ItemIdentifier = ItemIdentifier;
                class ItemTraits {
                    ItemIdentifier;
                    Qualifier;
                    LotNumber;
                    SerialNumber;
                    Cost;
                    ExpirationDate;
                    PalletIdentifier;
                }
                Models.ItemTraits = ItemTraits;
                class LocationBillingTypeIdentifier {
                    Name;
                    Id;
                }
                Models.LocationBillingTypeIdentifier = LocationBillingTypeIdentifier;
                class LocationIdentifier {
                    NameKey;
                    Id;
                }
                Models.LocationIdentifier = LocationIdentifier;
                class LocationNameKey {
                    FacilityIdentifier;
                    Name;
                }
                Models.LocationNameKey = LocationNameKey;
                class LocationTypeIdentifier {
                    Name;
                    Id;
                }
                Models.LocationTypeIdentifier = LocationTypeIdentifier;
                class MarkForListIdentifier {
                    Name;
                    Id;
                }
                Models.MarkForListIdentifier = MarkForListIdentifier;
                class OrderIdentifier {
                    Id;
                }
                Models.OrderIdentifier = OrderIdentifier;
                let OtherCustomerContactType;
                (function (OtherCustomerContactType) {
                    OtherCustomerContactType[OtherCustomerContactType["Invoicing"] = 2] = "Invoicing";
                    OtherCustomerContactType[OtherCustomerContactType["Additional"] = 3] = "Additional";
                    OtherCustomerContactType[OtherCustomerContactType["For753"] = 4] = "For753";
                    OtherCustomerContactType[OtherCustomerContactType["SmallParcelReturnLabel"] = 5] = "SmallParcelReturnLabel";
                })(OtherCustomerContactType = Models.OtherCustomerContactType || (Models.OtherCustomerContactType = {}));
                ;
                class PackageDefIdentifier {
                    Name;
                    Id;
                }
                Models.PackageDefIdentifier = PackageDefIdentifier;
                class PackingListTemplateIdentifier {
                    Name;
                    Id;
                }
                Models.PackingListTemplateIdentifier = PackingListTemplateIdentifier;
                class PalletIdentifier {
                    NameKey;
                    Id;
                }
                Models.PalletIdentifier = PalletIdentifier;
                class PalletNameKey {
                    FacilityIdentifier;
                    Name;
                }
                Models.PalletNameKey = PalletNameKey;
                class PalletTypeIdentifier {
                    Name;
                    Id;
                }
                Models.PalletTypeIdentifier = PalletTypeIdentifier;
                class ReceiveItemIdentifier {
                    Id;
                }
                Models.ReceiveItemIdentifier = ReceiveItemIdentifier;
                class ReceiverIdentifier {
                    Id;
                }
                Models.ReceiverIdentifier = ReceiverIdentifier;
                class RetailerIdentifier {
                    NameKey;
                    Id;
                }
                Models.RetailerIdentifier = RetailerIdentifier;
                class RetailerNameKey {
                    CustomerIdentifier;
                    Name;
                    Number;
                }
                Models.RetailerNameKey = RetailerNameKey;
                class SavedElement {
                    Name;
                    Value;
                }
                Models.SavedElement = SavedElement;
                class ScriptParameterDataTypeIdentifier {
                    Name;
                    Id;
                }
                Models.ScriptParameterDataTypeIdentifier = ScriptParameterDataTypeIdentifier;
                class ScriptParameterTemplateIdentifier {
                    Name;
                    Id;
                }
                Models.ScriptParameterTemplateIdentifier = ScriptParameterTemplateIdentifier;
                class ScriptTemplateIdentifier {
                    Name;
                    Id;
                }
                Models.ScriptTemplateIdentifier = ScriptTemplateIdentifier;
                class StorageCountUnitIdentifier {
                    Id;
                    Name;
                }
                Models.StorageCountUnitIdentifier = StorageCountUnitIdentifier;
                class ThreePlContactInfo {
                    Cell;
                    ContactId;
                    CompanyName;
                    Name;
                    Title;
                    Address1;
                    Address2;
                    City;
                    State;
                    Zip;
                    Country;
                    PhoneNumber;
                    Fax;
                    EmailAddress;
                    Dept;
                    IsAddressResidential;
                    Code;
                    AddressStatus;
                }
                Models.ThreePlContactInfo = ThreePlContactInfo;
                class ThreePlIdentifier {
                    Guid;
                    Name;
                    Id;
                }
                Models.ThreePlIdentifier = ThreePlIdentifier;
                class ThreePlOptions {
                    Integrations;
                    UserInterface;
                    Email;
                    Items;
                    Receiving;
                    Shipping;
                    OtherUserFeatures;
                }
                Models.ThreePlOptions = ThreePlOptions;
                class ThreePlReadOnly {
                    ThreePlId;
                    GuId;
                    Status;
                    CreationDate;
                    BillingHold;
                    IsPrivateWarehouse;
                    UseCognitoLogin;
                }
                Models.ThreePlReadOnly = ThreePlReadOnly;
                class TransactionIdentifier {
                    Id;
                }
                Models.TransactionIdentifier = TransactionIdentifier;
                class TransformIdentifier {
                    Name;
                    Id;
                }
                Models.TransformIdentifier = TransformIdentifier;
                class UiRoleIdentifier {
                    Name;
                    Id;
                }
                Models.UiRoleIdentifier = UiRoleIdentifier;
                class UnitOfMeasureIdentifier {
                    Name;
                    Id;
                }
                Models.UnitOfMeasureIdentifier = UnitOfMeasureIdentifier;
                class UserIdentifier {
                    Name;
                    Id;
                }
                Models.UserIdentifier = UserIdentifier;
                class WarehouseTransactionReadOnlyBase {
                    CustomerIdentifier;
                    FacilityIdentifier;
                    WarehouseTransactionSourceType;
                    TransactionEntryType;
                    ImportChannelIdentifier;
                    CreationDate;
                    CreatedByIdentifier;
                    LastModifiedDate;
                    LastModifiedByIdentifier;
                    Status;
                }
                Models.WarehouseTransactionReadOnlyBase = WarehouseTransactionReadOnlyBase;
                class WebHookParametersForEvents {
                    Name;
                    Resource;
                    EventTypes;
                    Url;
                    IncludeResource;
                    ResourceApiParameters;
                }
                Models.WebHookParametersForEvents = WebHookParametersForEvents;
                let Exceptions;
                (function (Exceptions) {
                    let ActionNameType;
                    (function (ActionNameType) {
                        ActionNameType[ActionNameType["Rel"] = 0] = "Rel";
                        ActionNameType[ActionNameType["ClassName"] = 1] = "ClassName";
                        ActionNameType[ActionNameType["Parser"] = 2] = "Parser";
                    })(ActionNameType = Exceptions.ActionNameType || (Exceptions.ActionNameType = {}));
                    ;
                    let AuErrorCode;
                    (function (AuErrorCode) {
                        AuErrorCode[AuErrorCode["UserNotAuthorizedForCustomerData"] = 0] = "UserNotAuthorizedForCustomerData";
                        AuErrorCode[AuErrorCode["UserNotAuthorizedForActionOnResource"] = 1] = "UserNotAuthorizedForActionOnResource";
                    })(AuErrorCode = Exceptions.AuErrorCode || (Exceptions.AuErrorCode = {}));
                    ;
                    class AuthorizationException {
                        Message;
                        ErrorCode;
                        Hint;
                        ProposedHttpStatus;
                        Data;
                        InnerException;
                        TargetSite;
                        StackTrace;
                        HelpLink;
                        Source;
                        HResult;
                    }
                    Exceptions.AuthorizationException = AuthorizationException;
                    class ListException {
                        Message;
                        Faults;
                        Data;
                        InnerException;
                        TargetSite;
                        StackTrace;
                        HelpLink;
                        Source;
                        HResult;
                    }
                    Exceptions.ListException = ListException;
                    let ModelType;
                    (function (ModelType) {
                        ModelType[ModelType["Api"] = 0] = "Api";
                        ModelType[ModelType["Orm"] = 1] = "Orm";
                        ModelType[ModelType["Other"] = 2] = "Other";
                    })(ModelType = Exceptions.ModelType || (Exceptions.ModelType = {}));
                    ;
                    let MvErrorCode;
                    (function (MvErrorCode) {
                        MvErrorCode[MvErrorCode["Required"] = 0] = "Required";
                        MvErrorCode[MvErrorCode["NotParsable"] = 1] = "NotParsable";
                        MvErrorCode[MvErrorCode["DoesNotExist"] = 2] = "DoesNotExist";
                        MvErrorCode[MvErrorCode["Duplicate"] = 3] = "Duplicate";
                        MvErrorCode[MvErrorCode["Incompatible"] = 4] = "Incompatible";
                        MvErrorCode[MvErrorCode["ValueNotSupported"] = 5] = "ValueNotSupported";
                        MvErrorCode[MvErrorCode["ColumnNotSupported"] = 6] = "ColumnNotSupported";
                        MvErrorCode[MvErrorCode["ColumnMissing"] = 7] = "ColumnMissing";
                    })(MvErrorCode = Exceptions.MvErrorCode || (Exceptions.MvErrorCode = {}));
                    ;
                    let MvValueNotSupportedHint;
                    (function (MvValueNotSupportedHint) {
                        MvValueNotSupportedHint[MvValueNotSupportedHint["ExceedsMaxLength"] = 0] = "ExceedsMaxLength";
                        MvValueNotSupportedHint[MvValueNotSupportedHint["Negative"] = 1] = "Negative";
                        MvValueNotSupportedHint[MvValueNotSupportedHint["OutOfRange"] = 2] = "OutOfRange";
                        MvValueNotSupportedHint[MvValueNotSupportedHint["IsNotLetterOrDigit"] = 3] = "IsNotLetterOrDigit";
                    })(MvValueNotSupportedHint = Exceptions.MvValueNotSupportedHint || (Exceptions.MvValueNotSupportedHint = {}));
                    ;
                    class OperationException {
                        ActionNameType;
                        ActionName;
                        Message;
                        ErrorCode;
                        Hint;
                        ProposedHttpStatus;
                        Data;
                        InnerException;
                        TargetSite;
                        StackTrace;
                        HelpLink;
                        Source;
                        HResult;
                    }
                    Exceptions.OperationException = OperationException;
                    let OpErrorCode;
                    (function (OpErrorCode) {
                        OpErrorCode[OpErrorCode["InUse"] = 0] = "InUse";
                        OpErrorCode[OpErrorCode["AsyncOperationUnavailable"] = 1] = "AsyncOperationUnavailable";
                    })(OpErrorCode = Exceptions.OpErrorCode || (Exceptions.OpErrorCode = {}));
                    ;
                    let QpErrorCode;
                    (function (QpErrorCode) {
                        QpErrorCode[QpErrorCode["Required"] = 0] = "Required";
                        QpErrorCode[QpErrorCode["NotParsable"] = 1] = "NotParsable";
                        QpErrorCode[QpErrorCode["DoesNotExist"] = 2] = "DoesNotExist";
                        QpErrorCode[QpErrorCode["AtLeastOneRequired"] = 3] = "AtLeastOneRequired";
                        QpErrorCode[QpErrorCode["MultipleResults"] = 4] = "MultipleResults";
                        QpErrorCode[QpErrorCode["NotSupported"] = 5] = "NotSupported";
                        QpErrorCode[QpErrorCode["Incompatible"] = 6] = "Incompatible";
                        QpErrorCode[QpErrorCode["Invalid"] = 7] = "Invalid";
                    })(QpErrorCode = Exceptions.QpErrorCode || (Exceptions.QpErrorCode = {}));
                    ;
                    class QueryParameterException {
                        Parameters;
                        Message;
                        ErrorCode;
                        Hint;
                        ProposedHttpStatus;
                        Data;
                        InnerException;
                        TargetSite;
                        StackTrace;
                        HelpLink;
                        Source;
                        HResult;
                    }
                    Exceptions.QueryParameterException = QueryParameterException;
                })(Exceptions = Models.Exceptions || (Models.Exceptions = {}));
            })(Models = Generic.Models || (Generic.Models = {}));
        })(Generic = V2.Generic || (V2.Generic = {}));
        let Inventory;
        (function (Inventory) {
            let Models;
            (function (Models) {
                class Adjustment {
                    Rel;
                    ReadOnly;
                    AdjustmentItems;
                    Billing;
                    SavedElements;
                    RowVersion;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Adjustment = Adjustment;
                class AdjustmentItem {
                    Rel;
                    Qty;
                    ReadOnly;
                    ItemIdentifier;
                    Qualifier;
                    ExternalId;
                    SecondaryQty;
                    LotNumber;
                    SerialNumber;
                    ExpirationDate;
                    Cost;
                    SupplierIdentifier;
                    LocationInfo;
                    PalletInfo;
                    WeightImperial;
                    WeightMetric;
                    OnHold;
                    OnHoldReason;
                    SavedElements;
                    CondensedSEs;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.AdjustmentItem = AdjustmentItem;
                class AdjustmentList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.AdjustmentList = AdjustmentList;
                class AdjustmentReadOnly {
                    AdjustmentId;
                    SubType;
                    RelatedAdjustmentId;
                    ProcessDate;
                    ReferenceNum;
                    PONumber;
                    Notes;
                    CustomerIdentifier;
                    FacilityIdentifier;
                    WarehouseTransactionSourceType;
                    TransactionEntryType;
                    ImportChannelIdentifier;
                    CreationDate;
                    CreatedByIdentifier;
                    LastModifiedDate;
                    LastModifiedByIdentifier;
                    Status;
                }
                Models.AdjustmentReadOnly = AdjustmentReadOnly;
                class Assembly {
                    Rel;
                    ReadOnly;
                    Etag;
                    Description;
                    Notes;
                    InvoiceNumber;
                    Qty;
                    LotNumber;
                    SerialNumber;
                    ExpirationDate;
                    Cost;
                    SupplierIdentifier;
                    LocationInfo;
                    PalletInfo;
                    Billing;
                    SavedElements;
                    AssemblyItems;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Assembly = Assembly;
                class AssemblyBase {
                    Description;
                    Notes;
                    InvoiceNumber;
                    Qty;
                    LotNumber;
                    SerialNumber;
                    ExpirationDate;
                    Cost;
                    SupplierIdentifier;
                    LocationInfo;
                    PalletInfo;
                    Billing;
                    SavedElements;
                    AssemblyItems;
                    Rel;
                    Href;
                    LinkName;
                    Links;
                }
                Models.AssemblyBase = AssemblyBase;
                class AssemblyCreate {
                    Rel;
                    CustomerIdentifier;
                    FacilityIdentifier;
                    WarehouseTransactionSourceEnum;
                    TransactionEntryTypeEnum;
                    ItemIdentifier;
                    ReferenceNum;
                    ExpectedDate;
                    AssemblyItemTrackByOptions;
                    Description;
                    Notes;
                    InvoiceNumber;
                    Qty;
                    LotNumber;
                    SerialNumber;
                    ExpirationDate;
                    Cost;
                    SupplierIdentifier;
                    LocationInfo;
                    PalletInfo;
                    Billing;
                    SavedElements;
                    AssemblyItems;
                    Href;
                    LinkName;
                    Links;
                }
                Models.AssemblyCreate = AssemblyCreate;
                class AssemblyItem {
                    Rel;
                    ReadOnly;
                    LotNumber;
                    SerialNumber;
                    MovableUnitLabel;
                    SplitLineByMovableUnit;
                    MovableUnitNumber;
                    ProposedAllocations;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.AssemblyItem = AssemblyItem;
                class AssemblyItemReadOnly {
                    OrderItemId;
                    ItemIdentifier;
                    Qualifier;
                    Qty;
                    SecondaryQty;
                    FullyAllocated;
                    ExpirationDate;
                    UnitIdentifier;
                    SecondaryUnitIdentifier;
                    EstimatedQty;
                    EstimatedSecondaryQty;
                    OriginalPrimaryQty;
                    IsOrderQtySecondary;
                    Bin;
                    RowVersion;
                    Allocations;
                }
                Models.AssemblyItemReadOnly = AssemblyItemReadOnly;
                class AssemblyList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.AssemblyList = AssemblyList;
                class AssemblyReadOnly {
                    AssemblyId;
                    ReferenceNum;
                    ItemIdentifier;
                    ProcessDate;
                    InvoiceExportedDate;
                    InvoiceDeliveredDate;
                    ExpectedDate;
                    CustomerDeactivated;
                    FullyAllocated;
                    HasAllocations;
                    CustomerIdentifier;
                    FacilityIdentifier;
                    WarehouseTransactionSourceType;
                    TransactionEntryType;
                    ImportChannelIdentifier;
                    CreationDate;
                    CreatedByIdentifier;
                    LastModifiedDate;
                    LastModifiedByIdentifier;
                    Status;
                }
                Models.AssemblyReadOnly = AssemblyReadOnly;
                class InventoryItem {
                    Rel;
                    ReceiverId;
                    ReceivedDate;
                    ReceiveItemId;
                    CustomerIdentifier;
                    FacilityIdentifier;
                    ItemIdentifier;
                    ItemDescription;
                    Description2;
                    Upc;
                    Qualifier;
                    InventoryUnitOfMeasureIdentifier;
                    SecondaryUnitOfMeasureIdentifier;
                    InventoryUnitsPerSecondaryUnit;
                    ReceivedQty;
                    OnHandQty;
                    AvailableQty;
                    OnHoldQty;
                    SecondaryReceivedQty;
                    SecondaryOnHandQty;
                    SecondaryAvailableQty;
                    SecondaryOnHoldQty;
                    WeightImperial;
                    WeightImperialOnHand;
                    WeightImperialAvailable;
                    WeightMetric;
                    WeightMetricOnHand;
                    WeightMetricAvailable;
                    SavedElements;
                    PackagingUnitOfMeasureIdentifier;
                    PrimaryUnitsPerPackagingUnit;
                    AvailablePackaging;
                    OnHandPackaging;
                    InventoryAgeDays;
                    LotNumber;
                    SerialNumber;
                    ExpirationDate;
                    Cost;
                    SupplierIdentifier;
                    LocationIdentifier;
                    PalletIdentifier;
                    PalletTypeIdentifier;
                    Imperial;
                    OnHold;
                    OnHoldReason;
                    OnHoldDate;
                    OnHoldUserIdentifier;
                    Quarantined;
                    RowVersion;
                    StockRowVersion;
                    ReferenceNum;
                    PONum;
                    TrailerNumber;
                    Href;
                    LinkName;
                    Links;
                }
                Models.InventoryItem = InventoryItem;
                class InventoryList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.InventoryList = InventoryList;
                class ItemInfo {
                    ReceiveItemId;
                    ItemIdentifier;
                    OrigQtyPrimary;
                    Available;
                    OnHold;
                }
                Models.ItemInfo = ItemInfo;
                class LocationInfo {
                    LocationId;
                    Display;
                    RawField1;
                    RawField2;
                    RawField3;
                    RawField4;
                }
                Models.LocationInfo = LocationInfo;
                class MarkInfo {
                    Candidate;
                    ChannelIdentifier;
                    TransformIds;
                }
                Models.MarkInfo = MarkInfo;
                class Pallet {
                    Rel;
                    Label;
                    FacilityIdentifier;
                    PalletTypeIdentifier;
                    Metric;
                    Imperial;
                    RowVersion;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Pallet = Pallet;
                class PalletInfo {
                    PalletId;
                    Label;
                    SplitOverCapacityOnCreate;
                    QtyOverrideOnSplit;
                    PalletTypeIdentifier;
                    Metric;
                    Imperial;
                }
                Models.PalletInfo = PalletInfo;
                class PalletList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.PalletList = PalletList;
                class ReceiptAdviceSendInfo {
                    MarkInfo;
                    SentInfo;
                }
                Models.ReceiptAdviceSendInfo = ReceiptAdviceSendInfo;
                class ReceiveItem {
                    Rel;
                    ReadOnly;
                    ItemIdentifier;
                    Qualifier;
                    ExternalId;
                    Qty;
                    SecondaryQty;
                    LotNumber;
                    SerialNumber;
                    ExpirationDate;
                    Cost;
                    SupplierIdentifier;
                    LocationInfo;
                    PalletInfo;
                    WeightImperial;
                    WeightMetric;
                    OnHold;
                    OnHoldReason;
                    SavedElements;
                    CondensedSEs;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ReceiveItem = ReceiveItem;
                class ReceiveItemReadOnly {
                    ReceiveItemId;
                    FullyShippedDate;
                    UnitIdentifier;
                    SecondaryUnitIdentifier;
                    ExpectedQty;
                    InventoryLevels;
                    OnHoldDate;
                    OnHoldUserIdentifier;
                    FacilityIdentifier;
                    ReferenceNumber;
                    TransactionID;
                    RowVersion;
                }
                Models.ReceiveItemReadOnly = ReceiveItemReadOnly;
                class Receiver {
                    Rel;
                    ReadOnly;
                    ReceiveItems;
                    Etag;
                    ReferenceNum;
                    PoNum;
                    ExternalId;
                    ReceiptAdviceNumber;
                    ArrivalDate;
                    ExpectedDate;
                    Notes;
                    Billing;
                    ShipTo;
                    ScacCode;
                    Carrier;
                    BillOfLading;
                    DoorNumber;
                    TrackingNumber;
                    TrailerNumber;
                    SealNumber;
                    CapacityTypeIdentifier;
                    NumUnits1;
                    Unit1Identifier;
                    NumUnits2;
                    Unit2Identifier;
                    TotalWeight;
                    TotalVolume;
                    SavedElements;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Receiver = Receiver;
                class ReceiverBase {
                    ReferenceNum;
                    PoNum;
                    ExternalId;
                    ReceiptAdviceNumber;
                    ArrivalDate;
                    ExpectedDate;
                    Notes;
                    Billing;
                    ShipTo;
                    ScacCode;
                    Carrier;
                    BillOfLading;
                    DoorNumber;
                    TrackingNumber;
                    TrailerNumber;
                    SealNumber;
                    CapacityTypeIdentifier;
                    NumUnits1;
                    Unit1Identifier;
                    NumUnits2;
                    Unit2Identifier;
                    TotalWeight;
                    TotalVolume;
                    SavedElements;
                    Rel;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ReceiverBase = ReceiverBase;
                class ReceiverDigest {
                    CustomerDeactivated;
                    CreationDate;
                    ArrivalDate;
                    ExpectedDate;
                    ReferenceNum;
                    PoNum;
                    ReceiptAdviceNumber;
                    Notes;
                    TrailerNumber;
                    ItemInfos;
                    ConfirmAsnSentDate;
                    DeferNotification;
                    ReceiptAdviceSent;
                    CanComplete;
                    CanCancel;
                    CanMarkForRa;
                    CanMarkSentRa;
                    Rel;
                    ReceiverId;
                    CustomerIdentifier;
                    FacilityIdentifier;
                    Status;
                    CanConfirm;
                    CanUnconfirm;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ReceiverDigest = ReceiverDigest;
                class ReceiverDigestBrief {
                    Rel;
                    ReceiverId;
                    CustomerIdentifier;
                    FacilityIdentifier;
                    Status;
                    CanConfirm;
                    CanUnconfirm;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ReceiverDigestBrief = ReceiverDigestBrief;
                class ReceiverDigestBriefList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ReceiverDigestBriefList = ReceiverDigestBriefList;
                class ReceiverDigestList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ReceiverDigestList = ReceiverDigestList;
                class ReceiverList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ReceiverList = ReceiverList;
                class ReceiverReadOnly {
                    ReceiverId;
                    ReceiverType;
                    DeferNotification;
                    ReceiptAdviceSendInfo;
                    CustomerIdentifier;
                    FacilityIdentifier;
                    WarehouseTransactionSourceType;
                    TransactionEntryType;
                    ImportChannelIdentifier;
                    CreationDate;
                    CreatedByIdentifier;
                    LastModifiedDate;
                    LastModifiedByIdentifier;
                    Status;
                }
                Models.ReceiverReadOnly = ReceiverReadOnly;
                class ReductionAllocation {
                    ReceiveItemId;
                    Qty;
                    ItemTraits;
                    LocationIdentifier;
                }
                Models.ReductionAllocation = ReductionAllocation;
                class SentInfo {
                    Sent;
                    Date;
                }
                Models.SentInfo = SentInfo;
            })(Models = Inventory.Models || (Inventory.Models = {}));
        })(Inventory = V2.Inventory || (V2.Inventory = {}));
        let Order;
        (function (Order_1) {
            let Models;
            (function (Models) {
                let LoadOutState;
                (function (LoadOutState) {
                    LoadOutState[LoadOutState["NotLoaded"] = 0] = "NotLoaded";
                    LoadOutState[LoadOutState["Loaded"] = 1] = "Loaded";
                    LoadOutState[LoadOutState["LoadedIncomplete"] = 2] = "LoadedIncomplete";
                })(LoadOutState = Models.LoadOutState || (Models.LoadOutState = {}));
                ;
                class Order {
                    Rel;
                    ReadOnly;
                    OrderItems;
                    Etag;
                    ReferenceNum;
                    Description;
                    PoNum;
                    ExternalId;
                    EarliestShipDate;
                    ShipCancelDate;
                    Notes;
                    NumUnits1;
                    Unit1Identifier;
                    NumUnits2;
                    Unit2Identifier;
                    TotalWeight;
                    TotalVolume;
                    BillingCode;
                    AsnNumber;
                    UpsServiceOptionCharge;
                    UpsTransportationCharge;
                    AddFreightToCod;
                    UpsIsResidential;
                    ExportChannelIdentifier;
                    RoutePickupDate;
                    ShippingNotes;
                    MasterBillOfLadingId;
                    InvoiceNumber;
                    FulfillInvInfo;
                    RoutingInfo;
                    Billing;
                    ShipTo;
                    SoldTo;
                    BillTo;
                    SavedElements;
                    ParcelOption;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Order = Order;
                class OrderDigest {
                    FacilityTimeZoneName;
                    ImportChannelIdentifier;
                    Status;
                    ReferenceNum;
                    PoNum;
                    Description;
                    RouteSent;
                    AsnSentDate;
                    AsnSent;
                    Notes;
                    DeferNotification;
                    PickDoneDate;
                    PackDoneDate;
                    PickTicketPrintDate;
                    ProcessDate;
                    ShipCancelDate;
                    CreationDate;
                    EarliestShipDate;
                    EndOfDayDate;
                    BillOfLading;
                    LoadNumber;
                    MasterBillOfLadingId;
                    PickupDate;
                    TrackingNumber;
                    TrackingUrl;
                    BillingCode;
                    Carrier;
                    Source;
                    LoadOutPercentage;
                    LoadOutDoneDate;
                    SmallParcelShipDate;
                    SmallParcelHvpBatchId;
                    SmallParcelHvpBatchName;
                    ShipTo;
                    ShipToRetailerIdentifier;
                    SavedElements;
                    MarkForLists;
                    OrderItemInfos;
                    HasAllocations;
                    ShipService;
                    CreatedByIdentifier;
                    CanMarkForAsn;
                    CanGenerateBol;
                    CustomerDeactivated;
                    PickerIdentifier;
                    ShippingNotes;
                    ShipDate;
                    Rel;
                    OrderId;
                    CustomerIdentifier;
                    FacilityIdentifier;
                    IsClosed;
                    BatchIdentifier;
                    FullyAllocated;
                    ScacCode;
                    TotPackages;
                    TotWeightMetric;
                    TotVolumeMetric;
                    TotWeightImperial;
                    TotVolumeImperial;
                    CanConfirm;
                    CanUnconfirm;
                    CanComplete;
                    CanCancel;
                    CanAllocate;
                    CanDeallocate;
                    CanSplit;
                    ParcelLabelType;
                    CanParcelExportTmw;
                    CanRegenPkgs;
                    PickJobId;
                    IsPickDone;
                    Href;
                    LinkName;
                    Links;
                }
                Models.OrderDigest = OrderDigest;
                class OrderDigestBrief {
                    Rel;
                    OrderId;
                    CustomerIdentifier;
                    FacilityIdentifier;
                    IsClosed;
                    BatchIdentifier;
                    FullyAllocated;
                    ScacCode;
                    TotPackages;
                    TotWeightMetric;
                    TotVolumeMetric;
                    TotWeightImperial;
                    TotVolumeImperial;
                    CanConfirm;
                    CanUnconfirm;
                    CanComplete;
                    CanCancel;
                    CanAllocate;
                    CanDeallocate;
                    CanSplit;
                    ParcelLabelType;
                    CanParcelExportTmw;
                    CanRegenPkgs;
                    PickJobId;
                    IsPickDone;
                    Href;
                    LinkName;
                    Links;
                }
                Models.OrderDigestBrief = OrderDigestBrief;
                class OrderDigestBriefList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.OrderDigestBriefList = OrderDigestBriefList;
                class OrderDigestList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.OrderDigestList = OrderDigestList;
            })(Models = Order_1.Models || (Order_1.Models = {}));
        })(Order = V2.Order || (V2.Order = {}));
        let Property;
        (function (Property) {
            let Models;
            (function (Models) {
                class BillingCode {
                    Code;
                    BillingCodeType;
                }
                Models.BillingCode = BillingCode;
                class CapacityType {
                    Rel;
                    CapacityTypeId;
                    Description;
                    Href;
                    LinkName;
                    Links;
                }
                Models.CapacityType = CapacityType;
                class CapacityTypeList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.CapacityTypeList = CapacityTypeList;
                class Carrier {
                    Rel;
                    Name;
                    Description;
                    NeedsBillOfLading;
                    ScacCode;
                    Deactivated;
                    DisallowOnOrder;
                    ShipmentServices;
                    BillingCodes;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Carrier = Carrier;
                class CarrierList {
                    Rel;
                    DefaultBillingCodes;
                    DefaultShipmentServices;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.CarrierList = CarrierList;
                class Country {
                    CountryCode;
                    Name;
                    Regions;
                }
                Models.Country = Country;
                class CountryList {
                    Rel;
                    Countries;
                    Href;
                    LinkName;
                    Links;
                }
                Models.CountryList = CountryList;
                class Facility {
                    Rel;
                    FacilityId;
                    Name;
                    Deactivated;
                    UsePredefinedLocations;
                    Code;
                    UpsAccount;
                    FedExAccount;
                    FuelSurcharge;
                    LocationFieldCount;
                    MeasurementSystemDefault;
                    LastCloseDate;
                    FreightRateLocationCode;
                    TimeZoneName;
                    ShippingZip;
                    Contact;
                    PreventPartialOrderManualAllocation;
                    RowVersion;
                    Etag;
                    Replenishment;
                    ReplenishFewestLocations;
                    AutoAllocateReplenish;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Facility = Facility;
                class FacilityList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.FacilityList = FacilityList;
                class FacilitySummary {
                    Rel;
                    FacilityId;
                    Name;
                    TimeZoneName;
                    Deactivated;
                    Href;
                    LinkName;
                    Links;
                }
                Models.FacilitySummary = FacilitySummary;
                class FacilitySummaryList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.FacilitySummaryList = FacilitySummaryList;
                class ItemClassification {
                    Rel;
                    Title;
                    Description;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ItemClassification = ItemClassification;
                class ItemClassificationList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ItemClassificationList = ItemClassificationList;
                class Location {
                    Rel;
                    AllocationPriority;
                    Field1;
                    Field2;
                    Field3;
                    Field4;
                    Description;
                    FacilityIdentifier;
                    LocationTypeIdentifier;
                    LocationBillingTypeIdentifier;
                    Quarantinable;
                    Height;
                    Width;
                    Length;
                    WeightAllowed;
                    TemperatureMinimum;
                    QuantityMinimum;
                    Zones;
                    PercentFill;
                    StoreOnlyPallets;
                    NumberPalletsAllowed;
                    LastCountedDate;
                    QuantityMax;
                    RowVersion;
                    Etag;
                    NonPickable;
                    ReplenishLocation;
                    ReplenishmentEnabled;
                    LocationId;
                    Name;
                    Deactivated;
                    HasInventory;
                    Href;
                    LinkName;
                    Links;
                }
                Models.Location = Location;
                class LocationBrief {
                    Rel;
                    LocationId;
                    Name;
                    Deactivated;
                    HasInventory;
                    Href;
                    LinkName;
                    Links;
                }
                Models.LocationBrief = LocationBrief;
                class LocationList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.LocationList = LocationList;
                class LocationListByFac {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.LocationListByFac = LocationListByFac;
                class PackageDef {
                    Rel;
                    PackageDefId;
                    Name;
                    Barcode;
                    Description;
                    IsDefault;
                    LengthImperial;
                    WidthImperial;
                    HeightImperial;
                    WeightImperial;
                    LengthMetric;
                    WidthMetric;
                    HeightMetric;
                    WeightMetric;
                    Cost;
                    DefaultMarkupPercent;
                    DefaultMarkupFlat;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.PackageDef = PackageDef;
                class PackageDefList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.PackageDefList = PackageDefList;
                class PalletType {
                    Rel;
                    Name;
                    Description;
                    LengthImperial;
                    WidthImperial;
                    HeightImperial;
                    WeightImperial;
                    LengthMetric;
                    WidthMetric;
                    HeightMetric;
                    WeightMetric;
                    MaterialType;
                    LoadType;
                    Cost;
                    DefaultRate;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.PalletType = PalletType;
                class PalletTypeList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.PalletTypeList = PalletTypeList;
                class Region {
                    RegionCode;
                    Name;
                }
                Models.Region = Region;
                class ShipmentService {
                    Code;
                    Description;
                    ShipEngineId;
                    Deactivated;
                }
                Models.ShipmentService = ShipmentService;
                class ThreePl {
                    Rel;
                    ReadOnly;
                    CompanyInfo;
                    BrandingFileName;
                    RecurringBillingId;
                    WebSite;
                    DandBNum;
                    FederalId;
                    Contact1;
                    Contact2;
                    Options;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.ThreePl = ThreePl;
                class UnitOfMeasureType {
                    Rel;
                    Name;
                    IsIntegral;
                    PluralDescription;
                    Href;
                    LinkName;
                    Links;
                }
                Models.UnitOfMeasureType = UnitOfMeasureType;
                class UnitOfMeasureTypeList {
                    Rel;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.UnitOfMeasureTypeList = UnitOfMeasureTypeList;
            })(Models = Property.Models || (Property.Models = {}));
        })(Property = V2.Property || (V2.Property = {}));
        let UIProperty;
        (function (UIProperty) {
            let Models;
            (function (Models) {
                class User {
                    Rel;
                    UserId;
                    CreationDate;
                    Deactivated;
                    Name;
                    Login;
                    NewPassword;
                    HintPhrase;
                    LastLoginDate;
                    V1Role;
                    EmailConfirmed;
                    Email;
                    CellPhone;
                    CellCarrierIdentifier;
                    UiRoleIdentifiers;
                    FacilityIdentifiers;
                    CustomerIdentifiers;
                    CanInvoiceTransactions;
                    CanAccessAllFacilities;
                    Provisioned;
                    Etag;
                    Href;
                    LinkName;
                    Links;
                }
                Models.User = User;
                class UserList {
                    Rel;
                    TotalResults;
                    ResourceList;
                    Href;
                    LinkName;
                    Links;
                }
                Models.UserList = UserList;
            })(Models = UIProperty.Models || (UIProperty.Models = {}));
        })(UIProperty = V2.UIProperty || (V2.UIProperty = {}));
        let WmsTool;
        (function (WmsTool) {
            let Models;
            (function (Models) {
                class WMSEvent {
                    Rel;
                    WMSEventId;
                    Datetime;
                    EventType;
                    TransactionId;
                    CustomerId;
                    ResourceLink;
                    OtherLinks;
                }
                Models.WMSEvent = WMSEvent;
            })(Models = WmsTool.Models || (WmsTool.Models = {}));
        })(WmsTool = V2.WmsTool || (V2.WmsTool = {}));
    })(V2 = WMS.V2 || (WMS.V2 = {}));
})(WMS || (WMS = {}));
exports.WMS = WMS;
;
